import React from 'react';
import { Box, Theme, withStyles } from '@material-ui/core';
import { paperBorderRadius, paperBoxShadow } from 'globals/styles';
import FsArrowRightIcon from 'ui-elements/icons/FsArrowRight';
import FsButton from 'ui-elements/buttons/FsButton';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';
import FsBody from 'ui-elements/typography/FsBody';

export const ContainerBox = withStyles((theme: Theme) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: paperBorderRadius,
    boxShadow: paperBoxShadow,
  },
}))(Box);

export const HeaderBox = withStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}))(Box);

export const SubHeaderBox = withStyles(({ spacing }) => ({
  root: {
    width: '100%',
    marginTop: spacing(0.5),
  },
}))(Box);

export const TitleBox = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
}))(Box);

export const SideHeaderBox = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
}))(Box);

export const Title = withStyles(() => ({
  root: {
    position: 'relative',
  },
}))(FsSubtitle);

export const SubTitle = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[300],
    wordWrap: 'break-word',
  },
}))(FsBody);

export const MoreButton = withStyles(({ spacing }) => ({
  root: {
    fontWeight: 600,
    fontSize: 14,
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    marginLeft: spacing(1.5),
    padding: spacing(0.5, 2),
  },
}))((props) => (
  <FsButton
    size="medium"
    color="primary"
    endIcon={<FsArrowRightIcon />}
    {...props}
  />
));

// export const TimePeriodContentBox = withStyles(({ spacing }: Theme) => ({
//   root: {
//     display: 'flex',
//     alignItems: 'center',
//     marginTop: spacing(0.5),
//   },
// }))(Box);

// export const TimePeriodTooltip = withStyles(({ palette }: Theme) => ({
//   arrow: {
//     color: palette.grey[400],
//   },
//   tooltip: {
//     maxWidth: 200,
//     backgroundColor: palette.grey[400],
//     color: palette.common.white,
//   },
// }))(Tooltip);

// export const TimePeriodLabel = withStyles(({ palette, spacing }: Theme) => ({
//   root: {
//     color: palette.grey[300],
//     marginLeft: spacing(0.2),
//   },
// }))(FsBodyExtraSmall);

// export const TimePeriodIcon = withStyles(({ palette }: Theme) => ({
//   root: {
//     color: palette.grey[300],
//     width: 16,
//     transform: 'translateY(-1px)',
//   },
// }))(DateRangeIcon);

export const ContentBox = withStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
}))(Box);
